import { Moon, Sun } from "lucide-react";
import { setMode, useMode } from "@/lib/theme";

export function ThemeToggle({ testId = "theme-mode-toggle" }) {
  const mode = useMode();
  const light = mode === "light";
  return (
    <button type="button" onClick={() => setMode(light ? "dark" : "light")} data-testid={testId}
            title={light ? "Gece moduna geç" : "Gündüz moduna geç"} aria-label="Tema modu"
            className="relative inline-flex h-9 w-16 items-center rounded-full border border-slate-700 bg-slate-800/60 px-1 transition-colors hover:border-slate-600">
      <span className={`absolute top-1 left-1 h-7 w-7 rounded-full bg-blue-600 shadow transition-transform duration-300 ${light ? "translate-x-0" : "translate-x-7"}`} />
      <Sun size={14} className={`relative z-10 ml-1.5 transition-colors ${light ? "text-white" : "text-slate-400"}`} />
      <Moon size={14} className={`relative z-10 ml-auto mr-1.5 transition-colors ${light ? "text-slate-400" : "text-white"}`} />
    </button>
  );
}
